import React, { Component } from 'react'

import Slide from './Slide';
import ToolBarWrapper from './ToolBarWrapper';

export default class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      isHidden: true,
    };
    this.handleCloseTool = this.handleCloseTool.bind(this);
  }

  handleMoreThemes = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  }

  handleCloseTool = () => {
    let urlDemo = this.props.currentDemo.domain;
    return window.location.href = urlDemo
  }

  render() {
    let isHidden = {
      display: this.state.isHidden ? "block" : "none"
    };
    return (
      <div className="toolbar" style={isHidden}>
        <Slide
          {...this.state}
          {...this.props}
          handleMoreThemes={this.handleMoreThemes}
        />
        <ToolBarWrapper
          {...this.props}
          {...this.state}
          handleMoreThemes={this.handleMoreThemes}
          handleCloseTool={this.handleCloseTool}
          handleScreen={this.props.handleScreen}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Toolbar.js